module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-1100.c13f6283.svg";